import validate from 'validate.js'

const constraints = {
  teachingTypes: {
    presence: true
  },
  topicId: {
    presence: true
  },
  serviceId: {
    presence: true
  },
  userId: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
